import { Stack } from '@mantine/core';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ClientEditFieldsKey } from 'stores/global/RootStore/AppConfigStore';
import { ClientEditFormStore } from 'stores/local/shared/ClientEditFormStore';

import FieldPhone from '../form/FieldPhone';
import FieldText from '../form/FieldText';

import s from './ClientEditForm.module.scss';

type ClientEditFormProps = {
  className?: string;
  store: ClientEditFormStore;
};

const ClientEditForm: React.FC<ClientEditFormProps> = ({ className, store }) => {
  const phoneField = store.fieldsMap[ClientEditFieldsKey.phone];
  const [isVisible, setIsVisible] = React.useState(false);

  React.useEffect(() => {
    if (phoneField.shouldShowFields) {
      // Небольшая задержка для плавного появления
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 50);

      return () => clearTimeout(timer);
    } else {
      setIsVisible(false);
    }
  }, [phoneField.shouldShowFields]);

  return (
    <Stack className={className} gap="xl">
      <FieldPhone data-autofocus label="Телефон" store={store.fieldsMap[ClientEditFieldsKey.phone]} />
      {phoneField.shouldShowFields && (
        <div className={cn(s.fields, isVisible && s.fields_visible)}>
          <Stack gap="xl">
            <FieldText label="Имя" store={store.fieldsMap[ClientEditFieldsKey.firstName]} />
            <FieldText label="Фамилия" store={store.fieldsMap[ClientEditFieldsKey.lastName]} />
            <FieldText label="Отчество" store={store.fieldsMap[ClientEditFieldsKey.patronymic]} />
            <FieldText label="Электронная почта" store={store.fieldsMap[ClientEditFieldsKey.email]} />
          </Stack>
        </div>
      )}
    </Stack>
  );
};

export default observer(ClientEditForm);
